import uiCore = require("../core/uicore");
//import personsdetailcontroller = require("./persons.detail.controller");
import persondetailscompetences = require("./person.details.competences");
import personcompetencescommon = require("./personcompetences.common");
import personrolecommon = require("./personrole/personrole.common");
import pesronworkplacecommon = require("./personworkplace/personworkplace.common");
import personJobTitlesDetails = require("./jobtitles/jobtitles.details");
import personJobTitlesEdit = require("./jobtitles/jobtitles.edit");
import personJobTitlesNew = require("./jobtitles/jobtitles.new");

export class ComponentsInstaller extends uiCore.BaseInstaller {

    constructor() {

        var pages = [
            //personsdetailcontroller.PersonsDetails,
            personJobTitlesDetails.JobTitleDetails,
            personJobTitlesEdit.JobTitleEdit,
            personJobTitlesNew.JobTitleNew,
            personcompetencescommon.PersonCompetencesDetails,
            personcompetencescommon.PersonCompetencesEdit,
            personcompetencescommon.PersonCompetencesNew,
            personrolecommon.PersonRoleDetails,
            personrolecommon.PersonRoleEdit,
            personrolecommon.PersonRoleNew,
            pesronworkplacecommon.PersonWorkplaceDetails,
            pesronworkplacecommon.PersonWorkplaceEdit,
            pesronworkplacecommon.PersonWorkplaceNew,
            
        ];
        var controls = [
            persondetailscompetences.PersonDetailsCompetencesDirective
        ];
        var installers = [];

        super(pages, controls, installers);
    } 
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/resources.installer.ts